import React from 'react';
import { useMsal } from '@azure/msal-react';
import VideoUpload from './VideoUpload';
import PromptSelector from './PromptSelector';
import ResultDisplay from './ResultDisplay';

const AuthenticatedContent = (props) => {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    
    const handleLogout = () => {
        instance.logoutRedirect();
    };
    
    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Video Query Tool</h1>
                <div className="d-flex align-items-center">
                    {activeAccount && (
                        <div className="me-3">
                            <small>Signed in as: <strong>{activeAccount.name}</strong></small>
                        </div>
                    )}
                    <button 
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleLogout}
                    >
                        Sign Out
                    </button>
                </div>
            </div>
            
            {!props.result && (
                <>
                    <VideoUpload onVideoSelect={props.onVideoSelect} />
                    
                    {props.selectedFile && (
                        <div className="mb-3">
                            <div className="alert alert-success d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-check-circle-fill me-2" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>
                                <div>
                                    <strong>Video selected:</strong> {props.fileName}
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <PromptSelector 
                        mode={props.mode}
                        onModeChange={props.onModeChange}
                        prompt={props.prompt}
                        onPromptChange={props.onPromptChange}
                        disabled={props.isLoading}
                    />
                    
                    {props.error && (
                        <div className="alert alert-danger mb-3">
                            {props.error}
                        </div>
                    )}
                    
                    <div className="d-grid gap-2 d-md-flex mb-4">
                        <button 
                            className="btn btn-primary"
                            onClick={props.handleProcessVideo}
                            disabled={!props.selectedFile || props.isLoading}
                        >
                            {props.isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Processing...
                                </>
                            ) : 'Process Video'}
                        </button>
                    </div>
                </>
            )}
            
            <ResultDisplay 
                result={props.result} 
                isLoading={props.isLoading} 
                uploadProgress={props.uploadProgress} 
            />
            
            {props.result && (
                <div className="mt-4">
                    <button className="btn btn-secondary" onClick={props.resetForm}>
                        Process Another Video
                    </button>
                </div>
            )}
        </div>
    );
};

export default AuthenticatedContent;